






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Chrome, Compact } from 'vue-color'
import tinycolor from 'tinycolor2'
import { isEqual } from 'lodash-es'
import { Icon } from '@alpha/ink'

export interface RGB {
  r: number;
  g: number;
  b: number;
}

export interface VueColorData {
  hex: string;
  hsl: {
    h: number;
    s: number;
    l: number;
    a: number;
  };
  hsv: {
    h: number;
    s: number;
    v: number;
    a: number;
  };
  rgba: {
    r: number;
    g: number;
    b: number;
    a: number;
  };
  a: number;
}

const defaultColor: RGB = { r: 14, g: 64, b: 38 }

@Component({
  components: {
    Chrome,
    Compact,
    Icon
  }
})
export default class ColorPicker extends Vue {
  @Prop({ default: () => (defaultColor) }) value: RGB = defaultColor

  colors: VueColorData = {
    hex: '',
    hsl: {
      h: 0,
      s: 0,
      l: 0,
      a: 0
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0,
      a: 0
    },
    rgba: {
      r: 0,
      g: 0,
      b: 0,
      a: 0
    },
    a: 0
  }

  showPopup = false
  clickedOutside = false

  created () {
    this.setColors(this.value)
  }

  // Couldn't do a simple click handler here cause if you click inside
  // the element and drag outside (which happens a lot with the picker),
  // it actually registers the component under the mouseup event as the
  // click target. So basically tracking if clicks start inside this
  // component or not
  mounted () {
    document.addEventListener('mousedown', this.handleMouseDown)
    document.addEventListener('mouseup', this.handleMouseUp)
    this.setColors(this.value)
  }

  beforeDestroy () {
    document.removeEventListener('mousedown', this.handleMouseDown)
    document.removeEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseDown (event: MouseEvent) {
    this.clickedOutside = true
  }

  handleMouseUp (event: MouseEvent) {
    if (this.clickedOutside) {
      this.showPopup = false
    }
    this.clickedOutside = false
  }

  setColors (rgb: RGB) {
    if (!rgb) {
      rgb = defaultColor
    }
    const color = tinycolor(rgb)
    this.colors = {
      hex: color.toHex(),
      rgba: color.toRgb(),
      hsl: color.toHsl(),
      hsv: color.toHsv(),
      a: 1
    }
  }

  @Watch('value')
  onValueChanged (val: RGB, oldVal: RGB) {
    if (isEqual(val, oldVal)) return
    this.setColors(val)
  }

  @Watch('colors')
  onColorsChanged (val: VueColorData, oldVal: VueColorData) {
    if (isEqual(val, oldVal)) return
    const { r, g, b } = val.rgba
    this.$emit('input', { r, g, b })
  }
}
